import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faDownload } from "@fortawesome/free-solid-svg-icons";
import SelectSearch from "react-dropdown-select";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

import { commonAPI } from "../services/CommonAPIService";
import { myFont } from "../common/fontBase64";
import curonext from "../assets/img/CuronextFinal.png";
import { ErrorSource } from "../common/constants";

const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    const date = new Date(dateTime);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
};
const getTodayDate = () => {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};
const selectStyle = {
    fontSize: "15px",
    borderColor: "#ccc",
    borderRadius: "4px",
    height: "40px",
    width: "96%",
    backgroundColor: "#fff",
    textAlign: "left",
    marginRight: 10,
};

const dropdownStyle = { width: "200px" };
const oneNextStyle = {
    width: "146px",
    minWidth: "146px",
    maxWidth: "146px",
};

const CustomRadio = ({ checked, label, onClick }) => (
    <div
        role="radio"
        aria-checked={checked}
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
        style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            whiteSpace: "nowrap",
            userSelect: "none",

            border: "1px solid rgb(204, 204, 204)",
            backgroundColor: "#fff",
            borderRadius: "5px",
            padding: "9px",

        }}
    >
        <span
            style={{
                width: "16px",
                height: "16px",
                minWidth: "16px",
                borderRadius: "50%",
                border: `2px solid ${checked ? "#0d6efd" : "#ced4da"}`,
                backgroundColor: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
            }}
        >
            {checked && (
                <span
                    style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#0d6efd",
                    }}
                />
            )}
        </span>
        <span style={{ fontSize: "14px", color: "#495057" }}>{label}</span>
    </div>
);

// Fully self-drawn checkbox indicator, same rationale as CustomRadio above.
const CustomCheckbox = ({ checked, label, onClick }) => (
    <div
        role="checkbox"
        aria-checked={checked}
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
        style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            whiteSpace: "nowrap",
            userSelect: "none",
        }}
    >
        <span
            style={{
                width: "16px",
                height: "16px",
                minWidth: "16px",
                borderRadius: "3px",
                border: `2px solid ${checked ? "#0d6efd" : "#ced4da"}`,
                backgroundColor: checked ? "#0d6efd" : "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
            }}
        >
            {checked && (
                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                    <path d="M1 4L3.5 6.5L9 1" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </span>
        <span style={{ fontSize: "14px", color: "#495057" }}>{label}</span>
    </div>
);

function ServiceStaffInOutReport({ show, onHide, UserData, fullscreen = true }) {
    // const [EntryGateList, setEntryGateList] = useState([]);
    // const [ExitGateList, setExitGateList] = useState([]);

    // const [SelectedEntryGate, setSelectedEntryGate] = useState("");
    // const [SelectedEntryGateName, setSelectedEntryGateName] = useState("");
    // const [SelectedExitGate, setSelectedExitGate] = useState("");
    // const [SelectedExitGateName, setSelectedExitGateName] = useState("");

    const [ReportFor, setReportFor] = useState("");
    const [CurrentlyIn, setCurrentlyIn] = useState(false);

    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");

    const [SearchData, setSearchData] = useState("");
    const [Loading, setLoading] = useState(false);

    const [StaffInOutData, setStaffInOutData] = useState([]);
    const [OldStaffInOutData, setOldStaffInOutData] = useState([]);

    const tableRef = useRef(null);

    const getUserData = () => {
        const auth = localStorage.getItem("userData");
        return auth ? JSON.parse(auth) : null;
    };

    // Reset the modal every time it is opened
    useEffect(() => {
        if (show) {
            // setSelectedEntryGate("");
            // setSelectedEntryGateName("");
            // setSelectedExitGate("");
            // setSelectedExitGateName("");
            setReportFor("");

            setCurrentlyIn(false);
            setStartDate("");
            setEndDate("");
            setSearchData("");
            setStaffInOutData([]);
            setOldStaffInOutData([]);
            // GetGateList();
        }
    }, [show]);

    // const GetGateList = async () => {
    //     const myUserData = getUserData();
    //     if (!myUserData) return;

    //     try {
    //         const endPointVariableKey = { urlVariable: null, buildingId: myUserData.buildingId };
    //         const response = await commonAPI("Gate", undefined, endPointVariableKey);
    //         if (response?.success) {
    //             const gates = response?.data || [];
    //             // setEntryGateList(gates);
    //             // setExitGateList(gates);
    //         } else {
    //             toast.error("Something went wrong while loading gates");
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         toast.error("Something went wrong while loading gates");
    //     }
    // };

    const GetServiceStaffInOutReport = async () => {
        const myUserData = getUserData();
        if (!ReportFor) { toast.warning("Please select either Today or Date Range"); return; }
        if (ReportFor === "dateRange") {
            if (!StartDate) { toast.warning("Please select Start Date"); return; } if (!EndDate) { toast.warning("Please select End Date"); return; }
            if (StartDate > EndDate) { toast.warning("End Date cannot be earlier than Start Date"); return; }
        }
        // if (ReportFor === "dateRange" && !StartDate) {
        //     toast.warning("Please select Start Date");
        //     return;
        // }
        // if (ReportFor === "dateRange" && !EndDate) {
        //     toast.warning("Please select End Date");
        //     return;
        // }

        const JSONRequest = {
            startDate:
                ReportFor === "today" || ReportFor === "dateRange"
                    ? StartDate
                    : null,

            endDate:
                ReportFor === "today" || ReportFor === "dateRange"
                    ? EndDate
                    : null,

            // entryGateId: SelectedEntryGate ? String(SelectedEntryGate) : null,
            // exitGateId: SelectedExitGate ? String(SelectedExitGate) : null,

            isCurrentlyIn: ReportFor === "today" ? CurrentlyIn : false,
        };

        try {
            setLoading(true);
            const endPointVariableKey = { urlVariable: null, buildingId: myUserData?.buildingId };

            // TODO: swap for the real endpoint once available, e.g.
            // const response = await commonAPI("ServiceStaffInOutReport", JSONRequest, endPointVariableKey);
            const response = await commonAPI("ServiceStaffInOutReport", JSONRequest, endPointVariableKey);

            if (response?.success && !response?.message?.length) {
                const data = response?.data || [];

                setStaffInOutData(data);
                setOldStaffInOutData(data);

                if (data.length === 0) {
                    toast.info("No data found");
                }
            } else if (!response?.success && response?.message?.length) {
                toast.error(response.message[0]);
                setStaffInOutData([]);
                setOldStaffInOutData([]);
            }
        } catch (error) {
            console.log(error);
            const bodyError = {
                userId: myUserData?.userId,
                mobileNumber: myUserData?.mobileNumber,
                requestJSON: JSONRequest,
                uri: "/api/Report/ServiceStaffInOutReport",
                errorNumber: "SS01",
                errorSource: ErrorSource,
                errorSummary: error.message,
                errorDescription: error.message,
                fileClassName: "ServiceStaffInOutReport.js",
                functionName: "GetServiceStaffInOutReport",
            };
            try {
                await commonAPI("ErrorLogMaster", bodyError);
            } catch (e) {
                console.log(e);
            }
            toast.error("Something went wrong, Please try again after some time");
        } finally {
            setLoading(false);
        }
    };

    const filterStaffInOutData = (text) => {
        setSearchData(text);
        const newData = OldStaffInOutData?.filter((item) =>
            Object.values(item || {}).some((value) =>
                value?.toString()?.toLowerCase()?.includes(text?.toLowerCase())
            )
        );
        setStaffInOutData(newData);
    };

    const handleExportExcel = () => {
        if (!StaffInOutData?.length) {
            toast.warning("No data to export");
            return;
        }
        const rows = StaffInOutData.map((item, index) => ({
            "S.No": index + 1,
            "Staff Name": item.userName,
            Mobile: item.mobileNumber,
            Gender: item.gender,
            "Staff Type": item.roleName,
            "Entry Date": formatDateTime(item.entryDateTime),
            // "Entry Gate": item.entryGateName,
            "Visiting Flats": item.entryFlats,
            "Carrying Assets": item.entryAssetCode,
            "Vehicle No.": item.vehicleNumber,
            "Vehicle Type": item.vehicleType,
            // "Body Temperature": item.bodyTemperature,
            // "Wearing Mask": item.isWearingMask ? "Yes" : "No",
            "Exit Date": formatDateTime(item.exitDateTime),
            // "Exit Gate": item.exitGateName,
            "Total In-Time": item.totalInTime,
        }));

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "ServiceStaffInOut");
        XLSX.writeFile(workbook, "Service-Staff-In-Out-Report.xlsx");
    };

    const ServiceStaffInOutPdf = () => {
        if (!StaffInOutData?.length) {
            toast.warning("No data to export");
            return;
        }

        setLoading(true);

        try {
            const doc = new jsPDF("l", "mm", "a4");

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            // Font
            doc.addFileToVFS("SourceSans3.ttf", myFont);
            doc.addFont("SourceSans3.ttf", "SourceSans3", "normal");
            doc.setFont("SourceSans3");

            // Current date/time
            const currentDate = new Date();

            const formattedDate =
                `${String(currentDate.getDate()).padStart(2, "0")}-` +
                `${String(currentDate.getMonth() + 1).padStart(2, "0")}-` +
                `${currentDate.getFullYear()}`;

            const formattedTime =
                `${String(currentDate.getHours()).padStart(2, "0")}:` +
                `${String(currentDate.getMinutes()).padStart(2, "0")}`;

            // ----------------------------------------------------
            // HEADER
            // ----------------------------------------------------

            const leftLogoWidth = 30;
            const leftLogoHeight = 10;
            const rightLogoWidth = 20;
            const rightLogoHeight = 10;

            if (UserData?.logo) {
                doc.addImage(
                    "data:image/jpeg;base64," + UserData.logo,
                    "JPEG",
                    5,
                    10,
                    rightLogoWidth,
                    rightLogoHeight
                );
            }

            doc.addImage(
                curonext,
                "PNG",
                pageWidth - leftLogoWidth - 5,
                10,
                leftLogoWidth,
                leftLogoHeight
            );

            doc.setFont("SourceSans3", "bold");
            doc.setFontSize(10);

            doc.text(
                `${UserData?.buildingName || ""}`,
                40,
                10
            );

            doc.setFont("SourceSans3", "normal");

            doc.text(
                `${UserData?.addressLine1 || ""} ${UserData?.addressLine2 || ""}`,
                40,
                15
            );

            doc.text(
                `${UserData?.city || ""}, ${UserData?.state || ""}`,
                40,
                20
            );

            // Report title
            doc.setFont("SourceSans3", "bold");
            doc.setFontSize(10);

            doc.text(
                "Service Staff In/Out Report",
                pageWidth / 2,
                30,
                { align: "center" }
            );

            // Criteria
            const criteriaText =
                // `Entry Gate: ${SelectedEntryGateName || "All"} | ` +
                // `Exit Gate: ${SelectedExitGateName || "All"} | ` +
                `Report For: ${ReportFor === "today" ? "Today" : "Date Range"} | ` +
                // `Start Date: ${StartDate || "-"} | ` +
                // `End Date: ${EndDate || "-"} | ` +
                `Start Date: ${formatDateTime(StartDate)} | ` +
                `End Date: ${formatDateTime(EndDate)} | ` +
                `Currently In: ${CurrentlyIn ? "Yes" : "All"}`;

            doc.setFont("SourceSans3", "normal");
            doc.setFontSize(10);

            doc.text(
                criteriaText,
                pageWidth / 2,
                36,
                { align: "center" }
            );

            // ----------------------------------------------------
            // TABLE HEADERS
            // ----------------------------------------------------

            const tableHeaders = [
                [
                    "S.No",
                    "Staff Name",
                    "Mobile",
                    "Gender",
                    "Staff Type",
                    "Entry Date",
                    // "Entry Gate",
                    "Visiting Flats",
                    "Carrying Assets",
                    "Vehicle No.",
                    "Vehicle Type",
                    "Exit Date",
                    // "Exit Gate",
                    "Total In-Time",
                ],
            ];

            // ----------------------------------------------------
            // TABLE DATA
            // IMPORTANT:
            // Keep exactly the same order as tableHeaders
            // ----------------------------------------------------

            const tableRows = StaffInOutData.map((item, index) => [
                index + 1,
                item?.userName || "",
                item?.mobileNumber || "",
                item?.gender || "",
                item?.roleName || "",
                formatDateTime(item?.entryDateTime),
                // item?.entryGateName || "",
                item?.entryFlats || "",
                item?.entryAssetCode || "",
                item?.vehicleNumber || "",
                item?.vehicleType || "",
                formatDateTime(item?.exitDateTime),
                // item?.exitGateName || "",
                item?.totalInTime || "",
            ]);

            // ----------------------------------------------------
            // PDF TABLE
            // ----------------------------------------------------
          doc.autoTable({
    startY: 45,

    head: tableHeaders,
    body: tableRows,

    // Full available landscape A4 width
    tableWidth: pageWidth - 10,

    theme: "plain",

    // ====================================================
    // HEADER
    // ====================================================
    headStyles: {
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],

        font: "helvetica",
        fontSize: 7.5,
        fontStyle: "bold",

        halign: "left",
        valign: "middle",

        cellPadding: {
            top: 2,
            right: 2,
            bottom: 2,
            left: 2,
        },

        lineWidth: 0,
    },

    // ====================================================
    // BODY
    // ====================================================
    bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],

        font: "helvetica",
        fontSize: 7.5,
        fontStyle: "normal",

        halign: "left",
        valign: "middle",

        cellPadding: {
            top: 1.8,
            right: 2,
            bottom: 1.8,
            left: 2,
        },

        lineWidth: 0,
    },

    alternateRowStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
    },

    // ====================================================
    // GENERAL
    // ====================================================
    styles: {
        font: "helvetica",
        fontSize: 7.5,
        textColor: [0, 0, 0],

        overflow: "linebreak",
        cellPadding: 1,

        lineWidth: 0,
    },

    // ====================================================
    // COLUMN WIDTHS
    // Total = 287mm
    // A4 Landscape = 297mm
    // Left + Right margin = 10mm
    // Available = 287mm
    // ====================================================
    columnStyles: {
        // S.No
        0: {
            cellWidth: 12,
            halign: "left",
        },

        // Staff Name
        1: {
            cellWidth: 25,
            halign: "left",
        },

        // Mobile
        2: {
            cellWidth: 18,
            halign: "left",
        },

        // Gender
        3: {
            cellWidth: 17,
            halign: "left",
        },

        // Staff Type
        4: {
            cellWidth: 24,
            halign: "left",
        },

        // Entry Date
        5: {
            cellWidth: 26,
            halign: "center",
        },

        // Visiting Flats
        6: {
            cellWidth: 38,
            halign: "left",
        },

        // Carrying Assets
        7: {
            cellWidth: 28,
            halign: "left",
        },

        // Vehicle No.
        8: {
            cellWidth: 24,
            halign: "left",
        },

        // Vehicle Type
        9: {
            cellWidth: 24,
            halign: "center",
        },

        // Exit Date
        10: {
            cellWidth: 26,
            halign: "center",
        },

        // Total In-Time
        11: {
            cellWidth: 25,
            halign: "center",
        },
    },

    // ====================================================
    // FORCE BLACK + ALIGNMENT
    // ====================================================
    didParseCell: function (data) {

        // ------------------------------
        // HEADER
        // ------------------------------
        if (data.section === "head") {

            data.cell.styles.fillColor = [245, 245, 245];
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "helvetica";
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fontSize = 7.5;

            // Center:
            // Entry Date, Vehicle Type, Exit Date, Total In-Time
            if (
                data.column.index === 5 ||
                data.column.index === 9 ||
                data.column.index === 10 ||
                data.column.index === 11
            ) {
                data.cell.styles.halign = "center";
            } else {
                data.cell.styles.halign = "left";
            }
        }

        // ------------------------------
        // BODY
        // ------------------------------
        if (data.section === "body") {

            data.cell.styles.fillColor = [255, 255, 255];
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "helvetica";
            data.cell.styles.fontStyle = "normal";
            data.cell.styles.fontSize = 7.5;

            // Entry Date
            if (data.column.index === 5) {
                data.cell.styles.halign = "center";
            }

            // Vehicle Type
            if (data.column.index === 9) {
                data.cell.styles.halign = "center";
            }

            // Exit Date
            if (data.column.index === 10) {
                data.cell.styles.halign = "center";
            }

            // Total In-Time
            if (data.column.index === 11) {
                data.cell.styles.halign = "center";
            }
        }
    },

    // ====================================================
    // MARGINS
    // ====================================================
    margin: {
        top: 10,
        left: 5,
        right: 5,
        bottom: 12,
    },

    // ====================================================
    // FOOTER
    // ====================================================
    didDrawPage: function () {

        const pageCurrent =
            doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFont("SourceSans3", "bold");
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);

        doc.text(
            `Generated on: ${formattedDate} ${formattedTime}`,
            5,
            pageHeight - 5
        );

        doc.text(
            `Page ${pageCurrent}`,
            pageWidth - 5,
            pageHeight - 5,
            {
                align: "right",
            }
        );
    },
});
            // ----------------------------------------------------
            // SAVE PDF
            // ----------------------------------------------------

            doc.save("Service-Staff-In-Out-Report.pdf");

        } catch (error) {
            console.error("PDF generation error:", error);
            toast.error("Unable to generate PDF");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            scrollable={false}
            fullscreen={fullscreen}
            show={show}
            onHide={onHide}
            dialogClassName="modal-100w clientmodal"
        >
            <Modal.Header className="headerMDL" closeButton>
                <Modal.Title>Service Staff In/Out Report</Modal.Title>
            </Modal.Header>
            <div className="textFromBehind">
                <p> Efficiently monitor and track service staff entry and exit activities, providing organized attendance monitoring and better overall staff movement management.</p>
            </div>
            <Modal.Body >
                <div className="row" id="validation">
                    <div className="col-12">
                        <div className="validation-wizard wizard-circle wizard clearfix">
                            <div className="container-fluid mt-3">
                                <div className="row">
                                    <div className="col-lg-10 col-md-10 col-sm-12 col-12">
                                        <div className="row">
                                            <div
                                                className="report__helpdesk_integration pt-0"
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    alignItems: "flex-start",
                                                    rowGap: "16px",
                                                    height: "auto",
                                                    minHeight: "0",
                                                    maxHeight: "none",
                                                    paddingBottom: 0,
                                                    marginBottom: 0,
                                                }}
                                            >
                                                {/* Entry Gate */}
                                                {/* <div className="oneNext" style={{ width: "210px", minWidth: "210px", maxWidth: "210px" }}>
                                                    <span className="syntax" style={{ position: "static" }}>Entry Gate</span>
                                                    <SelectSearch
                                                        isSearchable={true}
                                                        clearable={SelectedEntryGate ? true : false}
                                                        options={
                                                            EntryGateList
                                                                ? EntryGateList
                                                                    .filter(
                                                                        (item) =>
                                                                            item.gateType?.toLowerCase() === "entry"
                                                                    )
                                                                    .map((item) => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName,
                                                                    }))
                                                                : []
                                                        }
                                                        className="sltareamodal"
                                                        placeholder="All Entry Gate"
                                                        style={selectStyle}
                                                        dropdownStyle={dropdownStyle}
                                                        values={
                                                            SelectedEntryGate
                                                                ? [{ value: SelectedEntryGate, label: SelectedEntryGateName }]
                                                                : []
                                                        }
                                                        onChange={(values) => {
                                                            const sel = values?.[0];
                                                            setSelectedEntryGate(sel?.value || "");
                                                            setSelectedEntryGateName(sel?.label || "");
                                                        }}
                                                    />
                                                </div> */}

                                                {/* Exit Gate */}
                                                {/* <div className="oneNext" style={{ width: "210px", minWidth: "210px", maxWidth: "210px" }}>
                                                    <span className="syntax" style={{ position: "static" }}>Exit Gate</span>
                                                    <SelectSearch
                                                        isSearchable={true}
                                                        clearable={SelectedExitGate ? true : false}
                                                        options={
                                                            ExitGateList
                                                                ? ExitGateList
                                                                    .filter(
                                                                        (item) =>
                                                                            item.gateType?.toLowerCase() === "exit"
                                                                    )
                                                                    .map((item) => ({
                                                                        value: item.gateId,
                                                                        label: item.gateName,
                                                                    }))
                                                                : []
                                                        }
                                                        className="sltareamodal"
                                                        placeholder="All Exit Gate"
                                                        style={selectStyle}
                                                        dropdownStyle={dropdownStyle}
                                                        values={
                                                            SelectedExitGate
                                                                ? [{ value: SelectedExitGate, label: SelectedExitGateName }]
                                                                : []
                                                        }
                                                        onChange={(values) => {
                                                            const sel = values?.[0];
                                                            setSelectedExitGate(sel?.value || "");
                                                            setSelectedExitGateName(sel?.label || "");
                                                        }}
                                                    />
                                                </div> */}

                                                {/* Report For */}
                                                <div
                                                    className="oneNext"
                                                    style={{ width: "230px", minWidth: "230px", maxWidth: "230px", position: "static", overflow: "visible" }}
                                                >
                                                    <span className="syntax" style={{ position: "static", whiteSpace: "nowrap" }}>Report For</span>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            height: "40px",
                                                            gap: "18px",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        <CustomRadio
                                                            checked={ReportFor === "today"}
                                                            label="Today"
                                                            onClick={() => {
                                                                const today = getTodayDate();

                                                                setReportFor("today");

                                                                setStartDate(today);
                                                                setEndDate(today);
                                                            }}
                                                        />
                                                        <CustomRadio
                                                            checked={ReportFor === "dateRange"}
                                                            label="Date Range"
                                                            onClick={() => {
                                                                setReportFor("dateRange");
                                                                setCurrentlyIn(false);
                                                                setStartDate("");
                                                                setEndDate("");
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Check Box */}
                                                {ReportFor === "today" && (
                                                    <div
                                                        className="oneNext"
                                                        style={{ width: "170px", minWidth: "170px", maxWidth: "170px", position: "static", overflow: "visible" }}
                                                    >

                                                        <div style={{
                                                            display: "flex", alignItems: "center", border: "1px solid rgb(204, 204, 204)",
                                                            backgroundColor: "#fff",
                                                            borderRadius: "5px",
                                                            padding: "9px",
                                                            height: "40px", whiteSpace: "nowrap", marginTop: "21px"
                                                        }}>
                                                            <CustomCheckbox
                                                                checked={CurrentlyIn}
                                                                label="Currently - In"
                                                                onClick={() => setCurrentlyIn((prev) => !prev)}
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Start Date */}
                                                {ReportFor === "dateRange" && (
                                                    <div className="oneNext">
                                                        <span className="syntax" style={{ position: "static" }}>Start Date</span>
                                                        <input
                                                            type="date"
                                                            className="reportbtn"
                                                            max={getTodayDate()}
                                                            value={StartDate}
                                                            disabled={ReportFor === "today"}
                                                            onChange={(e) => setStartDate(e.target.value)}
                                                            id="ssStartDate"
                                                            name="startdate"
                                                            style={{ "padding": "9px 10px" }}
                                                        />
                                                    </div>
                                                )}
                                                {/* End Date */}
                                                {ReportFor === "dateRange" && (
                                                    <div className="oneNext">
                                                        <span className="syntax" style={{ position: "static" }}>End Date</span>
                                                        <input
                                                            type="date"
                                                            className="reportbtn"
                                                            max={getTodayDate()}
                                                            value={EndDate}
                                                            disabled={ReportFor === "today"}
                                                            onChange={(e) => setEndDate(e.target.value)}
                                                            id="ssEndDate"
                                                            name="enddate"
                                                            style={{ "padding": "9px 10px" }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-2 col-md-2 col-sm-12 col-12 align-content-center text-right">
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 pr-0" style={{ marginTop: "18px" }}>
                                                <a className="reportrun" style={{ padding: "10px 18px", marginTop: "20px" }} onClick={GetServiceStaffInOutReport}>Run Report</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: "12px" }}>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-right pr-0">
                                        <div className="filterUpperTop">
                                            <input
                                                type="text"
                                                className="onlysearch"
                                                value={SearchData}
                                                placeholder="Search"
                                                onChange={(e) => filterStaffInOutData(e.target.value)}
                                            />
                                            <FontAwesomeIcon icon={faSearch} className="searchico" />
                                            <div className="dropdown">
                                                <FontAwesomeIcon
                                                    icon={faDownload}
                                                    className="reportexlpdf ReportingTools dropdown-toggle float-right"
                                                    href=""
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                />
                                                <ul className="dropdown-content">
                                                    <li>
                                                        <button type="button" style={{ color: "#000" }} onClick={handleExportExcel}>
                                                            Export Excel
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            className="color"
                                                            type="button"
                                                            disabled={StaffInOutData?.length ? false : true}
                                                            onClick={() => ServiceStaffInOutPdf()}
                                                        >
                                                            Download PDF
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: "10px" }} ref={tableRef}>
                                    <div className="tableFixHead" style={{
                                        overflowX: "auto",
                                        overflowY: "auto",
                                        width: "100%",

                                    }}>
                                        <div style={{ height: "auto" }}>
                                            <Table striped responsive className="mb-0" style={{
                                                tableLayout: "fixed",
                                                minWidth: "1500px",
                                                width: "1500px",


                                            }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "8%" }}>Staff Name</th>
                                                        <th style={{ width: "5%" }}>Mobile</th>
                                                        <th style={{ width: "6%" }}>Gender</th>
                                                        <th style={{ width: "9%" }}>Staff Type</th>
                                                        <th style={{ width: "11%" }}>Entry Date</th>
                                                        {/* <th style={{ width: "8%" }}>Entry Gate</th> */}
                                                        <th style={{ width: "10%" }}>Visiting Flats</th>
                                                        <th style={{ width: "10%" }}>Carrying Assets</th>
                                                        <th style={{ width: "8%" }}>Vehicle No.</th>
                                                        <th style={{ width: "8%" }}>Vehicle Type</th>
                                                        <th style={{ width: "10%" }}>Exit Date</th>
                                                        {/* <th style={{ width: "8%" }}>Exit Gate</th> */}
                                                        <th style={{ width: "7%" }}>Total In-Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {StaffInOutData?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td style={{ width: "8%" }}>{item?.userName}</td>
                                                            <td style={{ width: "5%" }}>{item?.mobileNumber}</td>
                                                            <td style={{ width: "6%" }}>{item?.gender}</td>
                                                            <td style={{ width: "9%" }}>{item?.roleName}</td>
                                                            <td style={{ width: "7%" }}>{formatDateTime(item?.entryDateTime)}</td>
                                                            {/* <td style={{ width: "8%" }}>{item?.entryGateName}</td> */}
                                                            <td style={{ width: "7%" }}>{item?.entryFlats}</td>
                                                            <td style={{
                                                                width: "10%", whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                overflowWrap: "break-word",
                                                                verticalAlign: "top",
                                                            }}>{item?.entryAssetCode}</td>
                                                            <td style={{ width: "8%" }}>{item?.vehicleNumber}</td>
                                                            <td style={{ width: "8%" }}>{item?.vehicleType}</td>
                                                            <td style={{ width: "10%" }}>{formatDateTime(item?.exitDateTime)}</td>
                                                            {/* <td style={{ width: "8%" }}>{item?.exitGateName}</td> */}
                                                            <td style={{ width: "7%" }}>{item?.totalInTime}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default ServiceStaffInOutReport;